import { PhotoObjectDto } from "./PhotoObjectDto";

export class OutsidePhotoDto {
  id: string;
  surveyId: string;
  addressId: string;
  mimeType: string;
  originalPhotoData: string;
  originalBlob: File;
  photoData: string;
  blob: File;
  type: number;
  points: PhotoObjectDto[];
  backgroundImageMetadata: string;
  index: number;
  items = [];
  b64Parsed: boolean = false;

  constructor(obj: Partial<OutsidePhotoDto>) {
    Object.assign(this, obj);
    if (!this.items) this.items = [];
  }
}
